<template>
  <section>
    <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom">
      <h2 class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black">
        Shipment Activity Log
      </h2>
    </div>
    <div>
      <data-table :data="activityData">
        <template slot-scope="props">
          <b-table-column
            field="description"
            label="Shipping Application Current State"
          >{{props.row.description}}</b-table-column>
          <b-table-column field="date" label="Date and Time">{{props.row.action_date | moment("DD/MM/YYYY, hh:mma")}}</b-table-column>
          <b-table-column
            field="user_info"
            label="User Responsible"
          >{{props.row.causer.full_name}},{{props.row.causer.user_name}}, {{props.row.causer.email}}</b-table-column>
        </template>
        <template slot="empty">
          <section>
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"/>
              </p>
              <p>No Shipment Detail to display</p>
            </div>
          </section>
        </template>
      </data-table>
    </div>
  </section>
</template>

<script>
import DataTable from "@/modules/commonModule/components/dataTable/Main";

export default {
  name: "activity-information",
  components: { DataTable },
  props: {
    activityData: Array
  }
};
</script>
